import {ReplaySubject} from "rxjs/ReplaySubject";
import {Milestone, MilestoneService} from "./MilestoneService";
import {Observable} from "rxjs/Observable";
import {IsoDate} from "../../pseudo-types/DateTypes";
import {Scheduler} from "rxjs";
import {Milestones} from "./Milestones";

export class MilestoneStore {
    public static id = "milestoneStore";

    private current$ = new ReplaySubject<Milestones>(1);

    /** @ngInject */
    public constructor(private milestoneService: MilestoneService) {
        this.loadMilestones();
    }

    public get current(): Observable<Milestones> {
        return this.current$.asObservable()
                            .subscribeOn(Scheduler.async);
    }

    private async loadMilestones() {
        const milestones = await this.milestoneService.userMilestones();
        this.current$.next(new Milestones(milestones));
    }

    public completeMilestone(milestone: Milestone, completed: IsoDate | null = null) {
        const response = this.milestoneService.completeMilestone(milestone, completed);
        Observable.fromPromise(response).subscribe(this.loadMilestones.bind(this));
    }

}
